import { Redirect, Switch } from 'react-router-dom';
import { ContentRoute } from '../../../../_metronic/layout';
import { Permissions } from "../../../util/Permissions";
import { SubHeader } from '../../Common/layout/SubHeader';
import { PaymentTable } from './PaymentTable';
import WithdrawalRetryTable from "./WithdrawalRetryTable";


export const PaymentManagement = ({
    match: {
        params: { userGroup },
    },
}) => {
    return (
        <>
            <SubHeader>
                <SubHeader.Nav>
                    <SubHeader.NavItem label={"All"} to={`/payments/${userGroup}/all`} />
                    <SubHeader.NavItem label={"Pending Deposits"} to={`/payments/${userGroup}/pending-deposits`} />
                    <SubHeader.NavItem label={"Pending Withdrawals"} to={`/payments/${userGroup}/pending-withdrawals`} />
                    <SubHeader.NavItem label={"Retry Failed Withdrawals"} to={`/payments/${userGroup}/retry-failed-withdrawals`} />
                    <SubHeader.NavItem label={"Retried Withdrawals"} to={`/payments/${userGroup}/retried-withdrawals`} />
                    <SubHeader.NavItem label={"Flagged Withdrawals"} to={`/payments/${userGroup}/flagged`} />
                    <SubHeader.NavItem label={"Pending Review"} to={`/payments/${userGroup}/pending-review`} />
                    <SubHeader.NavItem label={"Portfolio Creation"} to={`/payments/${userGroup}/portfolio-deposit`} />
                    <SubHeader.NavItem label={"Virtual Card Creation"} to={`/payments/${userGroup}/virtual-card-creation`} />
                    <SubHeader.NavItem label={"Virtual Card Deposit"} to={`/payments/${userGroup}/virtual-card-deposit`} />
                </SubHeader.Nav>
            </SubHeader>
            <div className="py-4 px-6">
                <Switch>
                    <Redirect exact={true} from="/payments/:userGroup" to="/payments/:userGroup/all"/>

                    <ContentRoute path="/payments/:userGroup/all" permission={Permissions.PAYMENTS}>
                        <PaymentTable userGroup={userGroup} category={"all"} />
                    </ContentRoute>
                    <ContentRoute path="/payments/:userGroup/pending-deposits" permission={Permissions.PAYMENTS}>
                        <PaymentTable userGroup={userGroup} category={"pending-deposit"} />
                    </ContentRoute>
                    <ContentRoute path="/payments/:userGroup/pending-withdrawals" permission={Permissions.PAYMENTS}>
                        <PaymentTable userGroup={userGroup} category={"pending-withdraw"} />
                    </ContentRoute>
                    <ContentRoute path="/payments/:userGroup/flagged" permission={Permissions.PAYMENTS}>
                        <PaymentTable userGroup={userGroup} category={"flagged"} />
                    </ContentRoute>
                    <ContentRoute path="/payments/:userGroup/pending-review" permission={Permissions.PAYMENTS}>
                        <PaymentTable userGroup={userGroup} category={"pending-review"} />
                    </ContentRoute>
                    <ContentRoute path="/payments/:userGroup/retry-failed-withdrawals" permission={Permissions.PAYMENTS}>
                        <WithdrawalRetryTable mode={"retryable"} />
                    </ContentRoute>
                    <ContentRoute path="/payments/:userGroup/retried-withdrawals" permission={Permissions.PAYMENTS}>
                        <WithdrawalRetryTable mode={"retried"} />
                    </ContentRoute>
                    <ContentRoute path="/payments/:userGroup/portfolio-deposit" permission={Permissions.PAYMENTS}>
                        <PaymentTable userGroup={userGroup} category={"portfolio-deposit"} />
                    </ContentRoute>
                    <ContentRoute path="/payments/:userGroup/virtual-card-creation" permission={Permissions.PAYMENTS}>
                        <PaymentTable userGroup={userGroup} category={"virtual-card-creation"} />
                    </ContentRoute>
                    <ContentRoute path="/payments/:userGroup/virtual-card-deposit" permission={Permissions.PAYMENTS}>
                        <PaymentTable userGroup={userGroup} category={"virtual-card-deposit"} />
                    </ContentRoute>
                </Switch>
            </div>
        </>
    );
}
